import { useTranslation } from 'react-i18next'
import React from 'react'

import { ACTIONS_COL_WIDTH, COL_WIDTH, MAIN_COL_WIDTH, PADDING_COL_WIDTH } from './_constants'
import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { useProfiles } from '../_load/ProfilesLoader'
import LineSeparator from '../../../../packages/kiti/components/helpers/LineSeparator'
import PermissionActions from './PermissionActions'
import PermissionProfileSwitch from './PermissionProfileSwitch'
import Text from '../../../../packages/kiti/components/presentation/Text'

const PermissionsRows = ({ permissionDefinitions }) => {
  const { t } = useTranslation('editPermissions')
  const profiles = useProfiles()

  return permissionDefinitions.map(({ key, name }) => (
    <div key={key}>
      <LineSeparator />
      <Grid gutter={0.2} margin={0}>
        <Col width={PADDING_COL_WIDTH} />

        <Col width={MAIN_COL_WIDTH}>
          <Text size="small" bold color="dark2">
            {t(`permissions.${key}.title`)}
          </Text>
          <Text size="xsmall" color="dark2">
            {t(`permissions.${key}.description`)}
          </Text>
        </Col>

        <Col width={ACTIONS_COL_WIDTH} justify="center" align="center">
          <PermissionActions name={name} />
        </Col>

        {profiles.map(profile => (
          <Col key={profile.id} width={COL_WIDTH} justify="center" align="center">
            <PermissionProfileSwitch name={name} profile={profile} />
          </Col>
        ))}

        <Col width={COL_WIDTH} />
      </Grid>
    </div>
  ))
}

export default PermissionsRows
